import { foodImage, logo } from "@/assets";

const Template3 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const logoImage = template?.logo_url || logo;
  const templateTitle = previewData?.title || (isStrictPreview ? "N/A" : "ANNIVERSARY GIFT CARD");
  const customerName = previewData?.customerName || (isStrictPreview ? "Not provided" : "Md Rasel Mahmud");
  const cardCode = previewData?.code || (isStrictPreview ? "N/A" : "#32154232");
  const hasReward = previewData?.reward !== null && previewData?.reward !== undefined && previewData?.reward !== "";
  const reward = hasReward ? previewData?.reward : isStrictPreview ? "N/A" : 100;
  const rewardType = previewData?.rewardType || (isStrictPreview ? "" : "fixed");
  const quote = previewData?.message
    ? `\"${previewData.message}\"`
    : isStrictPreview
      ? "Not provided"
      : "\"Happy Anniversary\"";
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? "Not provided"
      : "Cash Only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? "Not provided"
      : "For dine in only ( not for Takeaway or Delivery )";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction ? "Not conjunction with any other offer" : null;
  const expiryText = previewData?.expiryDate || (isStrictPreview ? "N/A" : "12/05/2026");

  return (
    <div className="flex items-center justify-center p-4">
      {/* Main Card Container */}
      <div
        data-export-capture="gift-card-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex"
      >
        <div className="relative w-[62%] h-full bg-[#0B3D4D] flex flex-col items-center text-white text-center">
          <div className="bg-[#D3D9E0] text-[#0B3D4D] px-8 py-2 rounded-b-2xl mb-2 flex items-start">
            <span className="text-[10px] font-bold mt-1 mr-0.5">{rewardType === "percentage" || rewardType === "%" ? "" : "£"}</span>
            <span className="text-2xl font-bold leading-none">
              {reward}
              {rewardType === "percentage" || rewardType === "%" ? "%" : ""}
            </span>
          </div>

          <div className="mt-2">
            <h1 className="text-2xl font-bold uppercase tracking-wider leading-none">
              {templateTitle}
            </h1>
          </div>

    
          <div className="mt-2">
            <p className="text-base font-normal opacity-90">{customerName}</p>
            <p className="text-lg font-medium tracking-wide ">Code {cardCode}</p>
          </div>

          {quote && quote !== "Not provided" && quote !== "No provide" && quote !== "\"Not provided\"" && quote !== "\"No provide\"" && (
            <p className="italic text-sm text-gray-300 mt-2">{quote}</p>
          )}

          {((paymentText && paymentText !== "Not provided" && paymentText !== "No provide") ||
            (orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide") ||
            (conjunctionText && conjunctionText !== "Not provided" && conjunctionText !== "No provide") ||
            (expiryText && expiryText !== "N/A" && expiryText !== "Not provided" && expiryText !== "No provide")) && (
            <div className="mt-auto mb-4 text-[10px] opacity-90 tracking-wide">
              <p className="mb-0.5">-Terms & Conditions-</p>
              {paymentText && paymentText !== "Not provided" && paymentText !== "No provide" && <p>{paymentText}</p>}
              {orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide" && <p>{orderTypeText}</p>}
              {conjunctionText && conjunctionText !== "Not provided" && conjunctionText !== "No provide" && <p>{conjunctionText}</p>}
              {expiryText && expiryText !== "N/A" && expiryText !== "Not provided" && expiryText !== "No provide" && <p>Exp.Date: {expiryText}</p>}
            </div>
          )}
        </div>


        <div
          className="relative w-[38%] h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="absolute bottom-4 right-4 flex items-center bg-transparent">
            <img src={logoImage} alt="Logo" className="w-20" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template3;
